import { motion } from 'motion/react';
import styled from 'styled-components';
import { ANIMATION_CONFIG } from '../../../constants/animationConfig';

interface MotionHomeHeaderLeftImageProps {
  src: string;
  alt: string;
  className?: string;
  draggable?: boolean;
}

export const MotionHomeHeaderLeftImage = ({
  src,
  alt,
  className,
  draggable,
  ...props
}: MotionHomeHeaderLeftImageProps) => {
  return (
    <MotionHomeHeaderLeftImageWrapper
      src={src}
      alt={alt}
      {...props}
      className={className}
      draggable={draggable}
      initial={{
        opacity: 0,
        y: ANIMATION_CONFIG.homeHeader.leftImage.yOffset,
        x: ANIMATION_CONFIG.homeHeader.leftImage.xOffset,
      }}
      animate={{ opacity: 1, y: 0, x: 0 }}
      transition={{
        duration: ANIMATION_CONFIG.homeHeader.leftImage.duration,
        delay: ANIMATION_CONFIG.homeHeader.leftImage.delay,
        ease: 'easeIn',
        type: 'spring',
      }}
    />
  );
};

const MotionHomeHeaderLeftImageWrapper = styled(motion.img)``;
